// A little wizardy to measure the height of the mobile navigation kingdom - Developed by Fozail Ahmed
let navContainer = document.querySelector(".mob__nav__container");
let navHeight = window.getComputedStyle(navContainer).height;
document.documentElement.style.setProperty("--nav-height", navHeight);
let filtersSortByContainer = document.querySelector(".filters__sortby__container");

// Custom Functionality: Custom tweak to vanish the filters' details - especially conjured on top of Skeleton for Durex's charm ;)
let filtersDetailsTag = document.querySelector(".mobile-facets__disclosure.disclosure-has-popup");
if (filtersDetailsTag) {
  let filterCloseContainer = document.querySelector(".filter__close__container");
  if (filterCloseContainer) {
    filterCloseContainer.addEventListener("click", (e) => {
      e.target.closest('details').querySelector('summary').click();
    });
  }
}

// Custom Functionality: Custom tweak to vanish the sortby - especially conjured on top of Skeleton for Durex's charm ;)
class CustomSortOptions extends HTMLElement {
  constructor() {
    super();
    this.closeBtn = this.querySelector(".close-sort-options");
    if (this.closeBtn) {
      this.closeBtn.addEventListener("click", this.onCloseButtonClick.bind(this));
    }
  }

  onCloseButtonClick(event) {
    let detailsElement = this.closest("details");
    if (detailsElement && detailsElement.open) {
      detailsElement.open = false;
      event.preventDefault();
    }
  }
}

customElements.define('custom-sort-options', CustomSortOptions);

// Custom Functionality: Custom tweak to open the filter options initally - especially conjured on top of Skeleton for Durex's charm ;)
let filterItems = document.querySelectorAll(".filter__items");
if (filterItems.length > 0) {
  filterItems.forEach(function (item) {
    item.setAttribute("open", "");
    item.classList.add("menu-opening");
  });
}

// Custom Functionality: To make the mobile sort by button center aligned if the filters are disabled
document.addEventListener("DOMContentLoaded", function () {
  let menuDrawer = document.querySelector(".mobile-facets__wrapper");
  let filtersSortByContainer = document.querySelector(".filters__sortby__container");

  if (!menuDrawer && filtersSortByContainer) {
    filtersSortByContainer.style.justifyContent = "center";
  }
});

// A little wizardy to measure the height of the header kingdom
let header = document.querySelector("header");
let headerHeight = window.getComputedStyle(header).height;
document.documentElement.style.setProperty("--header-height", headerHeight);

// Magic Trick: This code transforms our humble mobile sub-categories container into a sticky buddy! It sticks to the header as you scroll up, making navigation a breeze! 
const mobileSubCategoriesContainer = document.querySelector('.mobile__sub__categories__container');
const mainCollectionProductGrid = document.querySelector('.collection__mobile__content__container');

window.addEventListener('scroll', () => {
  if (window.pageYOffset > mainCollectionProductGrid.offsetTop) {
    mobileSubCategoriesContainer?.classList.add('sticky');
  } else {
    mobileSubCategoriesContainer?.classList.remove('sticky');
  }
});
document.addEventListener("click", function (event) {
  const sortByElement = document.querySelector(".desktop__sort__by");
  const filterSortElements = document.querySelectorAll(".facet-filters__sort"); // Get all <details> elements

  if (sortByElement && !sortByElement.contains(event.target)) {
    filterSortElements.forEach((detailsElement) => {
      if (detailsElement.open) {
        detailsElement.open = false; // Properly closes each open <details>
      }
    });
  }
});